"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storage = exports.unwrap = exports.safeDataProxy = exports.EventEmitter = exports.usePromise = exports.get = exports.getParam = exports.featureAppName = exports.equalsIgnoreCase = exports.camelToDash = exports.dashToCamel = exports.partitionArray = exports.abbreviatedFA = void 0;
/**
 * oneAudi OS Utils
 * @copyright (c) Audi Business Innovation GmbH
 * @license Private
 */
var abbreviatedFA_1 = require("./abbreviatedFA");
Object.defineProperty(exports, "abbreviatedFA", { enumerable: true, get: function () { return abbreviatedFA_1.abbreviatedFA; } });
var arrays_1 = require("./arrays");
Object.defineProperty(exports, "partitionArray", { enumerable: true, get: function () { return arrays_1.partitionArray; } });
var dashToCamel_1 = require("./dashToCamel");
Object.defineProperty(exports, "dashToCamel", { enumerable: true, get: function () { return dashToCamel_1.dashToCamel; } });
var camelToDash_1 = require("./camelToDash");
Object.defineProperty(exports, "camelToDash", { enumerable: true, get: function () { return camelToDash_1.camelToDash; } });
var equalsIgnoreCase_1 = require("./equalsIgnoreCase");
Object.defineProperty(exports, "equalsIgnoreCase", { enumerable: true, get: function () { return equalsIgnoreCase_1.equalsIgnoreCase; } });
var featureAppName_1 = require("./featureAppName");
Object.defineProperty(exports, "featureAppName", { enumerable: true, get: function () { return featureAppName_1.featureAppName; } });
var getParam_1 = require("./getParam");
Object.defineProperty(exports, "getParam", { enumerable: true, get: function () { return getParam_1.getParam; } });
var get_1 = require("./get");
Object.defineProperty(exports, "get", { enumerable: true, get: function () { return get_1.get; } });
var usePromise_1 = require("./usePromise");
Object.defineProperty(exports, "usePromise", { enumerable: true, get: function () { return usePromise_1.usePromise; } });
var events_1 = require("./events");
Object.defineProperty(exports, "EventEmitter", { enumerable: true, get: function () { return events_1.EventEmitter; } });
__exportStar(require("./ssr"), exports);
__exportStar(require("./strings"), exports);
__exportStar(require("./typescript"), exports);
__exportStar(require("./functions"), exports);
var safeDataProxy_1 = require("./safeDataProxy");
Object.defineProperty(exports, "safeDataProxy", { enumerable: true, get: function () { return safeDataProxy_1.safeDataProxy; } });
Object.defineProperty(exports, "unwrap", { enumerable: true, get: function () { return safeDataProxy_1.unwrap; } });
exports.storage = __importStar(require("./storage"));
// Disabled for node.js support, but keeping here because sourcemaps will see the signature
// self.version = 'x.x.x-SNAPSHOT';
